<template>
  <div style="height: 100%;">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Application"
};
</script>



// WEBPACK FOOTER //
// src/components/Application.vue